export enum Experiment {
  EditorOOI = 'specs.loyalty.EditorOOI',
  FetchCustomRewardsFromSpi = 'specs.loyalty.FetchCustomRewardsFromSpi',
  CheckoutWidgetReturningUsers = 'specs.loyalty.CheckoutWidgetReturningUsers',
}
